import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';

import { CircularProgress } from '@material-ui/core';
import { FormServiceContext } from 'app/utils/contexts';
import { useDispatch, useSelector } from 'react-redux';
import { SERVICES_PROPERTIES } from 'app/config/services';
import { setupChangeEmailInitialValues, setupChangeEmailPayload } from 'app/utils/forms/services/change-email';
import notification from 'app/config/notification';
import { fetchServiceDocuments } from '../../../../../../store/slices/services';

const ChangeEmail = (props) => {
    const {
        intl,
        classes,
        loading,
        loadingDocuments,
        setLoadingDocuments,
        onCancel,
        onSave,
        onSubmit,
        initialValues,
        setInitialValues,
    } = props;

    const [canEdit] = useState(true);
    const [errorsList, setErrorsList] = useState({});

    const dispatch = useDispatch();
    const internalNewRequest = useSelector((state) => state.forms.internalNewRequest);
    const request = useSelector((state) => state.requests.details);
    const authUser = useSelector((state) => state.auth.user);

    useEffect(() => {
        const init = () => {
            let temp = {};
            if (Object.keys(internalNewRequest).length > 0) {
                dispatch(fetchServiceDocuments({ cdServico: internalNewRequest.cdServico }));
                temp = setupChangeEmailInitialValues(internalNewRequest);
            }
            setInitialValues(temp);
        };
        init();
    }, [internalNewRequest, setInitialValues, dispatch]);

    const validationSchema = useMemo(() => {
        return SERVICES_PROPERTIES[internalNewRequest.cdServico]
            ? SERVICES_PROPERTIES[internalNewRequest.cdServico].validationSchema
            : {};
    }, [internalNewRequest.cdServico]);

    const setupPayload = useCallback(
        (valuesCopy) => {
            return setupChangeEmailPayload({
                values: { ...valuesCopy, cdServico: internalNewRequest.cdServico },
                intl,
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [internalNewRequest.cdServico, intl],
    );

    const handleSave = useCallback(
        (values, fromSubmit, oldData) => {
            onSave(values, fromSubmit, oldData, setupPayload);
        },
        [onSave, setupPayload],
    );

    const handleSubmit = useCallback(
        (values) => {
            onSubmit(values, onSave, setupPayload);
        },
        [onSave, onSubmit, setupPayload],
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const validateForm = (functionValidation) => {
        functionValidation.then((res) => {
            if (Object.keys(res).length > 0) {
                notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                    toastId: 'VALIDATION',
                    type: 'error',
                });
            }
        });
    };

    const contextProvider = useMemo(() => {
        return {
            isInternalForm: false,
            hideActionBtn: true,
            hideFinalizeBtn: false,
            mainColor: 'secondary',
            loadingDocuments,
            setLoadingDocuments,
            onCancel,
            onSave: handleSave,
            onSubmit: handleSubmit,
            initialValues,
            validationSchema,
            validateOnSave: true,
            canEdit,
            user: authUser,
            errorsList,
            setErrorsList,
            validateForm: validateForm,
        };
    }, [
        authUser,
        canEdit,
        errorsList,
        handleSave,
        handleSubmit,
        initialValues,
        loadingDocuments,
        onCancel,
        setLoadingDocuments,
        validationSchema,
        validateForm,
    ]);

    const renderRequest = () => {
        const internalCdServico = internalNewRequest.cdServico || request.cdServico;
        let Component = SERVICES_PROPERTIES[internalCdServico] ? (
            SERVICES_PROPERTIES[internalCdServico].component
        ) : (
            <></>
        );
        return (
            <>
                {loading && (
                    <div className={classes.centerProgress}>
                        <CircularProgress size={20} />
                    </div>
                )}
                {!loading && (
                    <FormServiceContext.Provider value={contextProvider}>
                        <Component {...props} />
                    </FormServiceContext.Provider>
                )}
            </>
        );
    };

    return renderRequest();
};

export default injectIntl(ChangeEmail);
